import { useRedux } from "hooks"
import { useEffect, useState } from "react";
import { loadDllEmployee } from "../redux/workplace/wpActions";
import { WpSliceData } from "../redux/workplace/wpTypes";
import { createSelector } from "reselect";
import Select, { components, OptionProps, SingleValueProps, DropdownIndicatorProps, IndicatorSeparatorProps } from 'react-select';
import { Utils } from "helpers/utils";
import SelectDropdown from "./SelectDropdown";

interface UserOption {
  value: string;
  label: string;
  pictureUrl: string;
}

interface SelectDropdownEmpProps {
  onUserChanged: (userId: any) => void;
  selectedUserId?: number | null;

  isDisabled: boolean;
}

const SelectDropdownEmp = ({ selectedUserId, onUserChanged, isDisabled }: SelectDropdownEmpProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (wp: WpSliceData) => ({
      dllEmployee: wp.dllEmployee
    })
  );
  const { dllEmployee } = useAppSelector(storeData);
  const baseUrl = process.env.REACT_APP_APIURL ?? "";
  const imgProfileSize = 20;

  useEffect(() => {
    if (dllEmployee == null) {
      // console.log('reload dll employee');
      dispatch(loadDllEmployee());
    }
  }, []);

  const getUrl = (url: string): string => {
    let urlReturn = url;
    if (url.toLowerCase().startsWith("http")) {
      urlReturn = url;
    } else {
      urlReturn = baseUrl + url;
    }
    // console.log({url, urlReturn});
    return urlReturn;
  }

  const CustomOption = (props: OptionProps<UserOption>) => {
    const { data } = props;

    return (
      <components.Option {...props}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {/* <img
            src={getUrl(data.pictureUrl)}
            alt={data.label}
            style={{
              width: imgProfileSize,
              height: imgProfileSize,
              borderRadius: '50%',
              objectFit: 'cover',
            }}
          /> */}
          <span>{data.label}</span>
        </div>
      </components.Option>
    );
  };

  const CustomSingleValue = (props: SingleValueProps<UserOption>) => {
    const { data } = props;

    return (
      <components.SingleValue {...props}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {/* <img
            src={getUrl(data.pictureUrl)}
            alt={data.label}
            style={{
              width: imgProfileSize,
              height: imgProfileSize,
              borderRadius: '50%',
            }}
          /> */}
          <span>{data.label}</span>
        </div>
      </components.SingleValue>
    );
  };



  const dllInSelect: any[] = dllEmployee ?? [];

  return (
    <SelectDropdown
      isDisabled={isDisabled}
      list={dllInSelect}
      onValueChanged={onUserChanged}
      selectedValue={dllInSelect.find(e => e.value == selectedUserId) ?? null}
      customOption={CustomOption}
      customValue={CustomSingleValue}
    />
  )
}

export default SelectDropdownEmp

